<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        url="inventoryDetails"
        module="basic"
        height="62vh">
      <div slot="toolbar">
        <el-button type="primary" :loading="exportLoading" @click="exportFile">导出</el-button>
      </div>
      <div slot="adSearch">
        <vm-search label="唛头">
          <el-input v-model="filter.barcode"/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model="filter.factoryNo"/>
        </vm-search>
        <vm-search label="发货单号">
          <el-input v-model="filter.invoiceNo"/>
        </vm-search>
        <vm-search label="创建人">
          <el-input v-model="filter.creatorName"/>
        </vm-search>
        <vm-search label="扫描日期">
          <el-date-picker
              v-model="filter.scanTimeBegin"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="起始时间"/>
        </vm-search>
        <vm-search label="至" :label-width="65">
          <el-date-picker
              v-model="filter.scanTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="截止时间"/>
        </vm-search>
      </div>
      <el-table-column
          label="标准唛头编号"
          prop="packBarCode"
          align="center"
          width="150"
          show-overflow-tooltip/>
      <el-table-column
          label="客户专用唛头编号"
          prop="customerPackBarCode"
          align="center"
          width="150"
          show-overflow-tooltip/>
      <el-table-column label="出厂编号" prop="factoryNo" align="center" width="140"/>
      <el-table-column label="扫描时间" prop="scanTime" align="center" width="150"/>
      <el-table-column label="发货单号" prop="invoiceNo" align="center" width="120"/>
      <el-table-column label="发货单行项" prop="rowIndex" align="center" width="100"/>
      <el-table-column label="销售订单" prop="salesOrderNo" align="center" width="120"/>
      <el-table-column label="销单行项" prop="saleRowIndex" align="center" width="100"/>
      <el-table-column label="物料编号" prop="materialNo" align="center" width="120"/>
      <el-table-column
          label="物料描述"
          prop="materialName"
          align="center"
          width="400"
          show-overflow-tooltip/>
      <el-table-column label="发货单数量" prop="qty" align="center" width="100"/>
      <el-table-column label="特标" prop="specialMark" align="center" width="50"/>
      <el-table-column label="创建人" prop="creatorName" align="center" width="100"/>
      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template v-slot="scope">
          <el-button :loading="deleteLoading" type="danger" @click="deleteOne(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";

  export default {
    name: "InventoryDetail",
    components: {VmTable, VmSearch},
    data() {
      return {
        exportLoading: false,
        deleteLoading: false,
        filter: {
          factoryNo: "",
          invoiceNo: "",
          creatorName: "",
          scanTimeBegin: "",
          scanTimeEnd: "",
          barcode: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      exportFile() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "inventoryDetails/export", this.filter)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      deleteOne(row) {
        console.log(row);
        this.deleteLoading = true;
        this.$http.delete("basic", "inventoryDetails", row.pkid)
          .then(() => {
            this.$message.success("删除成功");
          }).catch(() => {
            this.$message.error("删除失败");
          }).finally(() => {
            this.deleteLoading = false;
            this.getList();
          });
      },
    },
  };
</script>

<style>

</style>